<script setup>
import { computed } from "vue";
import { useStore } from "vuex";

const store = useStore();
const isNavFixed = computed(() => store.state.isNavFixed);

const props = defineProps({
  currentPage: {
    type: String,
    default: "",
  },
  currentDirectory: {
    type: String,
    default: "",
  },
});

// --- FUNCIÓN LIMPIADORA DE TEXTO ---
const formatText = (text) => {
  if (!text) return "";
  
  // 1. Limpia los %20 (si es que llegan a existir)
  let cleanText = decodeURI(text);
  
  // 2. Reemplaza los guiones por espacios (ej: "nuevos-usuarios" -> "nuevos usuarios")
  cleanText = cleanText.replace(/-/g, ' ');
  
  // 3. Capitaliza la primera letra de cada palabra
  return cleanText.replace(/\b\w/g, char => char.toUpperCase());
};

// Variables reactivas listas para mostrar en el HTML
const paginaLimpia = computed(() => formatText(props.currentPage));
const directorioLimpio = computed(() => {
  const formateado = formatText(props.currentDirectory);
  if (formateado === "Dashboard Default" || formateado === "Dashboard") {
    return "Inicio";
  }
  return formateado;
});

</script>

<template>
  <nav aria-label="breadcrumb">
    <ol
      class="px-0 pt-1 pb-0 mb-0 bg-transparent breadcrumb me-sm-6"
      :class="isNavFixed ? 'text-dark' : 'text-white'"
    >
      <li class="text-sm breadcrumb-item">
        <a :class="isNavFixed ? 'text-dark' : 'text-white'" class="opacity-8" href="#">
          Página
        </a>
      </li>
      
      <li
        class="text-sm breadcrumb-item active"
        :class="isNavFixed ? 'text-dark' : 'text-white'"
        aria-current="page"
      >
        {{ paginaLimpia }}
      </li>
    </ol>
    
    <h6
      class="mb-0 font-weight-bolder"
      :class="isNavFixed ? 'text-dark' : 'text-white'"
    >
      {{ directorioLimpio }}
    </h6>
  </nav>
</template>